import React, { Component } from 'react';
import { Col, Row, Input } from "antd";

import { FormItem } from 'utils';


export default class TariffFieldSet extends Component {
  render() {
    const { form, sauna } = this.props;
    const { updateStatus, editObject } = sauna;
    const instance = editObject;

    const error = updateStatus.error || {};
    const errorData = error.data || {};

    return (
      <Row gutter={32}>
        <Col span={12}>
          <div className="form-block">
            <FormItem
              form={form}
              instance={instance}
              name="prices.hour"
              label="1 час"
              required={false}
              errorData={errorData}
            >
              <Input size="large" style={{ width: '100%' }} addonAfter="руб"/>
            </FormItem>
          </div>
        </Col>
      </Row>
    );
  }
}
